export enum NOTIFY_ACTION_TYPE {
  BADGE_COUNT = 'notify/badgeCount',
  LIST = 'notify/list',
  SHORT_LIST = 'notify/short_list',
  MARK_ALL_READ = 'notify/markAllRead',
  READ_ONE = 'notify/readOne',
}
